function e(e,r,i=!0){return{itemName:{displayName:e[r].displayName},required:i&&e[r].attribute.required}}export{e as unpackItems};
